import * as yup from 'yup';

const isAfterStart = function isAfterStart(value) {
  const { startTime } = this.parent || {};
  if (!startTime || !value) return false;
  try {
    const start = new Date(startTime);
    const end = new Date(value);
    return end.getTime() > start.getTime();
  } catch (e) {
    return false;
  }
};

const timeProfileSchema = yup.object().shape({
  startTime: yup.date().typeError('startTimeRequired').required('startTimeRequired'),
  endTime: yup.date()
    .typeError('endTimeRequired')
    .required('endTimeRequired')
    .test('is-after-start', 'endTimeMustBeAfterStartTime', isAfterStart),
  days: yup.array().of(yup.number()).min(1, 'daysRequired').required('daysRequired'),
});

const timeProfileFormSchema = yup.object().shape({
  name: yup.string().required('timeProfileNameRequired'),
  timeProfiles: yup.array().of(timeProfileSchema).min(1, 'timeProfilesRequired').required('timeProfilesRequired'),
});

export default timeProfileFormSchema;

